module.exports = __webpack_public_path__ + "static/media/puzzle0602.75627000.png";